/**
 * this is a utility function that helps us detect the top most accessible window:
 * (1.0) - return the top most accessible window - in cases like
 *      (1.1) - if we're in an about:blank iframe
 *      (1.2) - if we're in an empty-src iframe
 *      (1.3) - if we're in an iframe at the same-domain of his parent/parents windows
 * (2.0) - else return the current window
 */
function getTopmostAccessibleWindow(): Window {
  let accessibleWindow: Window = window;

  // trying to reach to top window directly
  try {
    if (top.document) {
      return top;
    }
  } catch {
    // no access to top window
  }

  try {
    while (accessibleWindow.parent.document) {
      accessibleWindow = accessibleWindow.parent;
    }
  } catch {
    // reached the topmost accessible window
  }

  return accessibleWindow;
}

export const topmostAccessibleWindow = getTopmostAccessibleWindow();

function checkCrossOriginIframe() {
  try {
    return (
      document.location.hostname !== "" &&
      document.location.hostname !== window.parent.location.hostname
    );
  } catch {
    return true;
  }
}

export const isCrossOriginFrame = checkCrossOriginIframe();

export function getPageURLObject() {
  try {
    return new URL(
      isCrossOriginFrame
        ? topmostAccessibleWindow.document.referrer
        : topmostAccessibleWindow.location.href,
    );
  } catch {
    return new URL(topmostAccessibleWindow.location.href);
  }
}

export const pageURLObject = getPageURLObject();
